import {
  destinationEmployeeDontAnswer,
  destinationExternalProblem,
  employeeUnwillingToDeliver,
  holiday,
  lateDestinationEmployee,
  lateOriginEmployee,
  noReason,
  originEmployeeDontAnswer,
  originExternalProblem,
  waitingResponse
} from '../../../assets/images/services';
import { NudosButton } from '../../NudosComponents';
import './ReportReasonsExampleModal.scss';

const ReportReasonsExampleModalContent = ({
  reasonId,
  closeModalCallback
}: {
  reasonId: number;
  closeModalCallback: () => void;
}) => {
  const reportImages: { [key: number]: string } = {
    1: originExternalProblem,
    2: destinationExternalProblem,
    3: originEmployeeDontAnswer,
    4: destinationEmployeeDontAnswer,
    5: waitingResponse,
    6: noReason,
    7: originExternalProblem,
    8: destinationExternalProblem,
    9: holiday,
    10: employeeUnwillingToDeliver,
    11: lateDestinationEmployee,
    12: lateOriginEmployee
  };
  const getImageByReasonId = () => reportImages?.[reasonId];

  return (
    <div className="reportReasonsExampleModalContent">
      <div className="reasonModalSubtitle">Visualiza un ejemplo del correo que recibirá el usuario</div>
      <img className="reasonImage" src={getImageByReasonId()} alt="reasonImage" />
      <NudosButton buttonText="Cerrar" customClassName="closeModalButton" handleClick={() => closeModalCallback()} />
    </div>
  );
};

export default ReportReasonsExampleModalContent;
